import {
  deleteAction,
  getAction,
  postAction,
  putAction,
  postRequest,
  fetchRequest,
} from './http/http.service';
import { PROJECT, WEBSITE_CODE } from '../store/types';
import { getStorage } from '../utils/storage';

// 數據字典
export const querySysDictionary = (dictCode) => getAction('/sys/dictItem/allList', { dictCode });

// 多語言字典下拉
export const querySysLangOptions = (params) => getAction('/sys/dictItem/languageTemplate', params);

// 多語言 字典下拉
export const querySysBmLangOptions = (params) => getAction('/sys/sysBmApplication/queryLanguageByCode', params);

// 多語言 數據
export const querySysLanguage = (params) => getAction('/sys/tSysLanguage/LoadingLanguage', params);

// 廣告輪播
export const queryAdvertiseList = (params) => getAction('/sys/portal/ad/list', params);

// 公告輪播
export const queryAnnouncementList = (params) =>
    getAction('/sys/systempannouncements/queryListByUser', params);

// 公告詳情
export const queryAnnouncementInformation = (params) =>
    getAction('/sys/systempannouncements/click/1', params);

// 用戶註冊(添加新用戶)
export const createUserItem = (params) => postAction('/sys/portal/user/add', params);

// 員工激活(添加新用戶)
export const activateUserItem = (params) => postAction('/sys/emp/activateUser', params);

// 獲取相信数据
export const queryUserInfoData = (params) => getAction("/sys/portal/user/getUserInfoBySSO");

// 查詢用戶信息
export const queryProfile = (params) =>
    getAction('/sys/portal/user/getUserInfoByLoginUser', params);
export const queryUserInformation = (params) =>
    getAction('/sys/portal/user/queryLoginUser', params);
export const queryPersonalInformation = (params) =>
    getAction('/sys/portal/user/decryptUserInfo', params);

// 验证 姓名 工號 手機號 郵箱 工號等是否已存在
export const checkUserInformation = (params) =>
    postAction('/sys/sysUserApply/checkUsernameAndWorkNoDuplicate', params);

// 發送圖片驗證碼
export const sendImageVerifyCode = (params) => getAction(`/sys/randomImage/${params}`);

// 發送短信驗證碼
export const sendSmsVerifyCode = (params) => postAction('/sys/portal/sms', params);

// 發送郵箱驗證碼
export const sendEmailVerifyCode = (params) => postAction('sys/portal/email', params);


// 忘記密碼
export const forgetUserPassword = (params) =>
    putAction('/sys/portal/user/passwordMobileChange', params);

// 相信激活設置密碼
export const settingActivationPassword = (params) => postAction('/sys/emp/activateUserSetPassWord', params);

// 相信授權設置密碼
export const settingIcivetPassword = (params) =>
    putAction('/sys/portal/user/setPasswordFirst', params);

// 根據工號查詢員工
export const queryEmployeeByWorkNo = (params) => getAction('/sys/employee/queryByWorkNo', params);

// 查詢問題反饋
export const queryFeedbacks = (params) => getAction(`/hhemp/feedback/list/${PROJECT.code}`,  params);

// 新增問題反饋
export const addFeedbackItem = (params) => postAction(`/hhemp/feedback/add/${PROJECT.code}`, params);

// 問題反饋類型
export const queryFeedbackType = (params) => getAction(`/sys/dict/getItems/emp_freeback_type`, params);

// 問題反饋類型
export const queryFeedbackCategory = (params) => getAction('/sys/dictItem/allListByLanguage', params);

// 問題反饋评分
export const feedbackEdit = (params) => postAction(`/hhemp/feedback/edit`, params);

// 問題反饋詳情
export const queryFeedbackInformation = (params) => getAction(`/hhemp/feedback/queryById/${params.id}`);

// 內容點擊次數，交互埋點: 參數：id(內容的id)
export const updateEventTrackingCount = (params) => getAction(`/hhemp/colContent/clickContent`, params);



/* ***************************************************** */

// 查询用户信息
export const queryProfile2 = (params) =>
  postAction('/sys/user/queryVoByUserName', params);

// 登錄訪問統計
export const querySignVisit = (params) => postAction(`/sys/getLoginCount`, params);

// 站點
export const queryAreaWebsiteList = (params) => getAction(`/gam/gamarea/allList`, params);

// 站點TOKEN
export const queryAreaWebsiteToken = (params) => getAction(`/gam/CmsAPI/getToken?areaCode=${params?.areaCode}`);

// 站點簽名
export const queryAreaWebsiteSign = (params) => getAction(`/gam/CmsAPI/getCMSSign?areaCode=${params?.areaCode}`);


// 發送郵箱驗證碼
export const sendEmailValidateCode = (params) => postAction(`/sys/sendVerifyMail`, params);

// 郵箱驗證
export const emailFactorValidate = (params) => postAction(`/sys/verifyEmailLogin`, params);

// 发送短信验证码
export const sendSmsValidateCode = (params) => postAction(`/sys/sms2fa`, params);

// 短信驗證
export const smsFactorValidate = (params) => postAction(`/sys/verifyPhoneLogin`, params);

// 修改個人信息
export const updateUserInformation = (params) => putAction('/sys/user/editUser', params);

// 修改密碼
export const updateUserPassword = (params) => putAction('/sys/user/changePassword', params);

// 驗證密碼
export const validateUserPassword = (params) => postAction('/sys/verifyUserPassword', params);


// 服务专区-廠區管理-廠區列表
export const queryFactoryList = (params) => getAction(`/sys/mail/factory/getFactoryListByArea`, params);

// 服务专区-廠區管理-根據廠區ID聯動廠區單位收發點
export const queryFactoryStationaryList = (params) => getAction(`/sys/mail/address/getAddressPointByFactoryId`, params);

// 服务专区-人員列表查詢
export const queryFactoryUserList = (params) => getAction(`/sys/mail/address/getEpmList`, params);


/* ***************************************************** */


// 服务专区-餐飲-一卡通消費記錄  参数：workNo(必填)、startDate(开始时间、非必填)、endDate(结束时间、非必填)、FactoryName(非必填，非模糊查询)、pageNo(页面 默认1)、 pageSize(每页数量，默认10)
export const querySmartCardConsumptionList = (params) => getAction(`/gam/smartCardApi/consumptionRecords`, params);

// 服务专区-餐飲-一卡通廠區列表
export const querySmartCardFactoryList = (params) => getAction(`/gam/smartCardApi/factorys`, params);



// 服务专区-收發-收發人信息
export const queryPostalUserInformation = (params) => getAction(`/gam/bill/getUerInfo`, params);

// 服务专区-收發-寄件新增
export const createPostalMail = (params) => postAction(`/gam/bill/addSendMail`, params);

// 服务专区-收發-信件編輯
export const updatePostalMail = (params) => postAction(`/gam/bill/edit`, params);

// 服务专区-收發-刪除信件
export const deletePostalMail = (params) => deleteAction(`/gam/bill/delete`, params);

// 服务专区-收發-信件列表
export const queryPostalMail = (params) => getAction(`/gam/bill/getMailUserList`, params);

// 服务专区-收發-信件導入
export const queryPostalFileUpload = (params, callback) => {
  return postRequest(`/gam/bill/importMailList`, params, callback)
};

// 服务专区-收發-模板下載
export const queryPostalTemplateDownload = (params, callback) => fetchRequest(`/gam/bill/exportTemplate`, params, callback);

//
export const queryPostalEmployees = (params) => postAction(`/gam/epm/syncEpmData?workNo=${params?.workNo}`);

// 留言回复-新增留言
export const createCommentItem = (params) => postAction(`/gam/gamMessage/add`, params);

// 留言回复-敏感关键词
export const querySensitiveKeyWorks = (params) => getAction(`/gam/CmsAPI/getKeyWorks`, params);

// 留言回复-回應列表
export const queryResplyList = (params) => getAction(`/gam/gamMessage/getMyResplyList`, params);

// 有話要說-留言列表
export const queryRepairServiceList = (params) => getAction(`/gam/gamMessage/getRepairServiceList`, params);


// 有話要說-留言Item詳情
export const queryRepairServiceDetails = (params) => getAction(`/gam/gamMessage/queryById/${params?.id}`);

// 有話要說-客服回复-標記已讀
export const updateMarkAllRecordsReaded = (params) => getAction(`/gam/gamMessage/markAllRecordsReaded`, params);


// 有話要說-客服回复-有无帮助
export const createCommentHaveHelp = (params) => getAction(`/gam/gamMessage/haveHelp`, params);

/*
* 給予評價
* params: [object, object, ...]
* object: { question: '問題1', answer: '答案1', orderNo: 0 }
*/
export const createEvaluationItem = (params) => postAction(`/gam/giveEvaluation/addContent`, params);



// 個性化通知-個人通知 
export const queryUserAnnouncementSend = (params) => getAction(`/gam/gamMessage/getUserServiceList`, params);

// 個性化通知-系統通知
export const querySysAnnouncementSend = (params) => getAction(`/sys/sysAnnouncementSend/getMyAnnouncementSend`, { applicationCode: PROJECT.code, component: 'system/UserAnnouncementList', areaCode: getStorage(WEBSITE_CODE), ...params});

// 個性化通知-設置已讀
export const updateSysAnnouncementSend = (params) => putAction(`/sys/sysAnnouncementSend/editByAnntIdAndUserId`, { applicationCode: PROJECT.code, component: 'system/UserAnnouncementList', areaCode: getStorage(WEBSITE_CODE), ...params});

// 個性化通知-一鍵已讀
export const updateSysAnnouncementReadAll = (params) => getAction(`/sys/sysAnnouncementSend/readAll`, params);

/* ***************************************************** */

export const uploadFiles = (formData, callback) => postRequest(`${process.env.REACT_APP_API_BASE_URL}/sys/common/upload?applicationCode=${PROJECT.code}&isShiro=1`, formData, callback);













// 獲取樓棟數據:  参数：factoryId （厂区id）
export const queryShareofficeBuildingList = (params) => getAction(`/gam/shareofficeBuilding/getList`, params);

// 獲取樓層數據:  参数：buildId（楼栋id）
export const queryShareofficeFloorList = (params) => getAction(`/gam/shareofficefloor/getList`, params);


// 待办任务：
export const queryTodoProcess = (params) => getAction(`/sys/bpm/process/todoProcess`, params);

// 已办任务：
export const queryFinishedProcess = (params) => getAction(`/sys/bpm/process/finishedProcess`, params);


/*
* 簽核流程 同意或退回作業
* params: {
*	"action":"",// Y：同意，R：退回
*	"businessFormNo":"",// 簽核單號
*	"reviewerId":"",// 簽核人工號
*	"remarks":""// 簽核意見 }
*/ 
export const updateSignedProcess = (params) => postAction(`/sys/bpm-signed/process/${params?.businessFormNo}`, params);

//  簽核節點歷史記錄
/* 
* 参数: businessFormNo 
*   withSignCode(默认为0,为0时不含未签核的节点信息，返回值是list；为1时包含未签核的节点信息，返回值是map)
*/ 
export const queryProcessTaskList = (params) => getAction(`/sys/bpm/processTaskUserResult/getlistByBusinessFormNo`, params);





// 共享办公室-签核用户列表查询API
export const queryUserListByAreaCode = (params) => getAction(`/gam/gamuserarea/getUserListByAreaCode`, params);


/* 
* 共享办公室UX-我要申請
* demandDateStart(2025-01-01);开始时间
* demandDateEnd(2025-09-10);结束时间
* factoryId;厂区id
* tenancyType;承租类型
*/ 
export const queryShareofficeSourceList = (params) => getAction(`/gam/shareofficeInformation/getListByFactory`, params);


/*
* 共享办公室UX-指定厂区下共享办公室列表
* canUseFlag
* factoryId info tenancyType buildId startDateStr endDateStr floorId shareofficeTypeId	 pageNo pageSize
*/ 
export const queryShareofficeListByFactory = (payload, params) => postAction(`/gam/shareofficeInformation/getShareofficeList?pageNo=${payload?.pageNo}&pageSize=${payload?.pageSize}`, params);


/*
* 共享办公室UX-申请订单-申请订单储存草稿-只有申请订单提交-只有候補订单提交-申请候補混合提交
* actionCode	操作方式code: save:保存 ;saveAndSign :送签
* gamShareofficeApplyPage 	申请订单对象
* modelCode     modelCode,示例值(ShareOffice_applyOrder)
*/
export const createShareofficeApply = (params) => postAction(`/gam/gamShareoffice/gamShareofficeApply/addApply?actionCode=${params?.actionCode}`, params?.gamShareofficeApplyPage);
 

// 共享办公室UX-申请订单-通过id删除明细项
export const deleteShareofficeApplyDetailsItem = (params) => deleteAction(`/gam/gamShareoffice/gamShareofficeApply/deleteDetailById`, params);

 
// 共享办公室UX-申请订单新增-当前用户信息 
export const queryShareofficeApplyUerInfo = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/getUerInfo`, params);


/* **************************************************************************** */ 

// 共享办公室UX-我的申请
export const queryShareofficeApplyList = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/getMyApplyList`, params);

// 共享办公室UX-申请订单-手动取消
export const cancelShareofficeApplyItem = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/cancleApply`, params);


// 共享办公室UX-申请订单-通过id删除
export const deleteShareofficeApplyItem = (params) => deleteAction(`/gam/gamShareoffice/gamShareofficeApply/delete`, params);


// 共享办公室UX-申请订单-通过id終止
export const stopShareofficeApplyItem = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/stopApply`, params);


// 共享办公室UX-申请订单-编辑
export const editShareofficeApplyItem = (params) => putAction(`/gam/gamShareoffice/gamShareofficeApply/editApply?actionCode=${params?.actionCode}`, params?.gamShareofficeApplyPage);

/*
* 共享办公室UX-申请订单-编辑-单号-详情查询
* params: params?.id   params?.formNo
*/ 
export const queryShareofficeApplyById = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/queryById`, params);


/* **************************************************************************** */ 




/* **************************************************************************** */ 


// 共享办公室UX-我的草稿
export const queryShareofficeApplyDraftList = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/getDraftApplyList`, params);


/* **************************************************************************** */ 



/* **************************************************************************** */ 


// 共享办公室UX-历史表单
export const queryShareofficeApplyHistoryList = (params) => getAction(`/gam/gamShareoffice/gamShareofficeApply/getMyHistoryList`, params);

/* **************************************************************************** */ 








/* **************************************************************************** */ 

// 共享办公室UX-我的候補
export const queryShareofficeApplyWaitList = (params) => getAction(`/gam/gamShareoffice/gamShareofficeWait/getWaitList`, params);


// 共享办公室UX-候補订单-编辑-单号-详情查询
export const queryShareofficeWaitById = (params) => getAction(`/gam/gamShareoffice/gamShareofficeWait/queryById`, params);


// 共享办公室UX-候補订单-手动取消
export const cancelShareofficeWaitItem = (params) => getAction(`/gam/gamShareoffice/gamShareofficeWait/cancleWait`, params);

// 共享办公室UX-候補订单-通过id删除明细项
export const deleteShareofficeWaitDetailsItem = (params) => deleteAction(`/gam/gamShareoffice/gamShareofficeWait/deleteDetailById`, params);

// 共享办公室UX-候補订单-通过id删除
export const deleteShareofficeWaitItem = (params) => deleteAction(`/gam/gamShareoffice/gamShareofficeWait/delete`, params);

// 共享办公室UX-候補订单-終止
export const stopShareofficeWaitItem = (params) => getAction(`/gam/gamShareoffice/gamShareofficeWait/stopWait`, params);

// 共享办公室UX-候補订单-编辑
export const editShareofficeWaitItem = (params) => putAction(`/gam/gamShareoffice/gamShareofficeWait/edit?actionCode=${params?.actionCode}`, params?.gamShareofficeApplyPage);



/* **************************************************************************** */ 
/* **************************************************************************** */ 
/* **************************************************************************** */ 
/* **************************************************************************** */ 



// 共享办公室UX-变更订单-变更前校验数据
export const validateShareofficeChangeItem = (params) => getAction(`/gam/gamShareoffice/gamShareofficeChange/checkApplyCanChange`, params);

// 共享办公室UX-变更订单-提交
export const createShareofficeChangeItem = (params) => postAction(`/gam/gamShareoffice/gamShareofficeChange/add?actionCode=${params?.actionCode}`, params?.gamShareofficeChangePage);

// 共享办公室UX-变更订单-编辑-单号-详情查询
export const queryShareofficeChangeById = (params) => getAction(`/gam/gamShareoffice/gamShareofficeChange/queryById`, params);

// 共享办公室UX-变更订单-变更-查询最新明细记录 
/*
* applyId	申请单单头id	query	true	
* string
* changeType	变更类型( 1 :续租 ; 2 : 扩租/减租)	query	true	
* string
* endDateStr	需求截止日期(yyyy-MM-dd)	query	true	
* string
* startDateStr	需求開始日期(yyyy-MM-dd)	query	true	
* string
* changeRentStartDate	擴租/減租開始日期(yyyy-MM-dd)	query	false	
* string
* continueRentEndDate 租截止日期(yyyy-MM-dd)
*/ 
export const queryShareofficeChangeDetailList = (params) => getAction(`/gam/gamShareoffice/gamShareofficeChange/getChangeDetailList`, params);

// 共享办公室UX-变更订单-編輯
export const editShareofficeChangeItem = (params) => putAction(`/gam/gamShareoffice/gamShareofficeChange/edit?actionCode=${params?.actionCode}`, params?.gamShareofficeApplyPage);


// 共享办公室UX-变更订单-終止
export const stopShareofficeChangeItem = (params) => getAction(`/gam/gamShareoffice/gamShareofficeChange/stopChange`, params);

// 共享办公室UX-变更订单-刪除
export const deleteShareofficeChangeItem = (params) => deleteAction(`/gam/gamShareoffice/gamShareofficeChange/delete`, params);

// 共享办公室UX-变更单-通过id删除明细项
export const deleteShareofficeChangeDetailItem = (params) => deleteAction(`/gam/gamShareoffice/gamShareofficeChange/deleteDetailById`, params);



// 共享办公室UX-查詢可租數 shareofficeTypeIdList startDateStr endDateStr
export const queryShareofficeCanUseNumByOfficeId = (params) => postAction(`/gam/gamShareoffice/gamShareofficeApply/getCanUseNumByOfficeId`, params);